import Vue from 'vue'
import Router from 'vue-router'

const router = new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'HomePage',
    //   component: HomePage
    // },
  ]
})

export default router

router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})

Vue.use(Router)



// WEBPACK FOOTER //
// ./src/router/index.js